import React from 'react';
import PropTypes from 'prop-types';
import { PipelineField, PipelineAction } from './';
import { Row, Col } from 'react-bootstrap';

class PipelineStep extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { step, job, client, } = this.props;
    let Component;
    let completed = false;

    switch(step.type) {
      case 'field':
        Component =  PipelineField;
        break;
      case 'action':
        Component = PipelineAction;
        break;
    }
    return <Component ref={'component'} {...step} job={job} client={client} />
  }
}

export default PipelineStep;



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline-step.js